import { useSearchParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Select } from "../components/ui";
import PlatformDashboard from "../components/Status/PlatformDashboard";
import type { PlatformFilter } from "../types/status";

export default function ServiceStatusPage() {
  const { user } = useAuth();
  const isAdmin = ["admin", "super_admin"].includes(user?.role?.name ?? "");
  const [searchParams, setSearchParams] = useSearchParams();

  const raw = searchParams.get("platform");
  const platform: PlatformFilter = raw === "phoenix" || raw === "kraken" ? raw : "all";

  function handlePlatformChange(next: PlatformFilter) {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (next === "all") params.delete("platform");
      else params.set("platform", next);
      return params;
    }, { replace: true });
  }

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-gray-900 !m-0">Platform Health</h1>
          <p className="mt-0.5 text-sm text-gray-500">
            Uptime, errors and infrastructure signals — translated into what they mean for the business
          </p>
        </div>
        <Select value={platform} onChange={(e) => handlePlatformChange(e.target.value as PlatformFilter)}>
          <option value="all">All platforms</option>
          <option value="phoenix">Phoenix</option>
          <option value="kraken">Kraken</option>
        </Select>
      </div>

      <PlatformDashboard platform={platform === "all" ? undefined : platform} isAdmin={isAdmin} />
    </div>
  );
}
